import { getPage } from '../custom_api/api';
import { Jumbo } from '../custom_components/components/jumbo';
export const fetchEventsOverviewJumboDNB = async ()=>{
    const page = await getPage('/activiteiten', '');
    const result = page == 'error' || page == 'loading' ? fallback : {
        title: page.headerTitle,
        contents: page.description,
        imageUrl: page.imageUrl,
        imageUrlFallback: page.imageUrlFallback,
        imageUrlLarge: page.imageUrl,
        imageAlt: page.imageAlt,
        size: 'small',
        kind: 'activity-overview'
    };
    return {
        kind: 'result',
        value: result,
        status: 200
    };
};
const fallback = {
    title: 'Activiteiten',
    contents: '',
    imageUrl: '',
    imageUrlFallback: '',
    imageUrlLarge: '',
    imageAlt: '',
    size: 'small',
    kind: 'activity-overview'
};
export const renderDNBJumbo = (props)=>Jumbo({
        ...props
    });
